module.exports = __webpack_public_path__ + "media/take-my-hand.2aeeba1e.mp3";